module.exports = __webpack_public_path__ + "static/media/teaser-prognose-staenderatswahlen.fa37bcad.jpg";